import { UAParser } from 'ua-parser-js';

const uaParser = new UAParser();

export const Browser = {
  info: uaParser.getBrowser(),
  device: uaParser.getDevice(),
  os: uaParser.getOS(),
  userAgent: uaParser.getUA(),
  isAndroid: uaParser.getOS().name?.includes('Android'),
  isSafari: uaParser.getBrowser().name?.includes('Safari'),
  isIOS:
    /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1),
};
